import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'signUpPageShown',
  'signUp',
  'signUpWithGoogleClick',
  'signUpWithSSOClick',
  'emailSignUpEntered',
  'passwordSignUpEntered',
  'emailSignUpProceedClick',
  'confirmYourEmailScreenShown',
  'confirmEmailButtonClick',
  'backToSignUpFromCodeClick',
  'resendConfirmationCodeClick',
] as const;

export const signUpEvents = getMappedEvents([...EVENTS]);
